<template>
  <generic-modal
    size="medium"
    :title="$t('course configuration')"
    icon="book"
    image="/images/icons/course.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <generic-container
        v-bind:searchable="false"
        v-bind:show_plus="true"
        icon="list"
        :title="$t('attributes')"
        v-on:add="add_attribute"
      >
        <div class="ui form">
          <div
            class="fields"
            v-for="(attribute, index) in attributes"
            v-bind:key="index"
          >
            <div class="eight column wide field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="attributes[index].name" />
            </div>
            <div class="six column wide field">
              <label for>{{ $t("type") }}</label>
              <div
                class="ui search selection dropdown"
                ref="type"
                :data-index="index"
              >
                <input
                  name="type"
                  type="hidden"
                  v-model="attributes[index].type"
                />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("type") }}</div>
                <div class="menu">
                  <div class="item" data-value="text">
                    <i class="font icon"></i>
                    {{ $t("text") }}
                  </div>
                  <div class="item" data-value="numeric">
                    <i class="digital tachograph icon"></i>
                    {{ $t("numeric") }}
                  </div>
                  <div class="item" data-value="email">
                    <i class="at icon"></i>
                    {{ $t("email") }}
                  </div>
                  <div class="item" data-value="date">
                    <i class="calendar icon"></i>
                    {{ $t("date") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="two column wide field">
              <label for>`</label>
              <div
                class="ui mini red icon button"
                v-on:click="remove_attribute(attribute, index)"
              >
                <i class="trash icon"></i>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";

export default {
  components: {
    "generic-modal": GenericModal,
    "generic-container": GenericContainer,
  },
  computed: {},
  data() {
    return {
      attributes: [],
    };
  },
  methods: {
    add_attribute() {
      let attribute = { id: v4(), name: "", type: "" };
      this.attributes.push(attribute);
    },
    remove_attribute(attribute, index) {
      this.attributes.splice(index, 1);
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/course/setting/do-save-configuration", {
          s: { attributes: vm.attributes },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/course/setting/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.attributes) {
          vm.attributes = conf.setup.attributes;
        }
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });
  },
  watch: {},
  updated: function() {
    let vm = this;
    this.$nextTick(function() {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        },
      });
    });
  },
};
</script>
